<template>
    <div class="container">
        <!-- 头部 -->
        <Header />

        <div class="news">
            <div class="top_img">
                <img :src="Baseurl+list.home_image" alt="">
            </div>
            <!-- 323 303 -->
            <!-- 300 300 -->
            <div class="public_title">
                <div class="pumain">
                    <div class="pubbiao">{{list.name}}</div>
                </div>
            </div>
            <div class="newscont_bg ">
                <div class="newscont main">
                    <div class="anlist" v-for="(item,index) in olists" :key="index" @click="todetails(item.id)">
                        <div class="fangan">Solutions</div>
                        <div class="topimg">
                            <img :src="Baseurl+item.image" alt="">
                        </div>
                        <div class="antext">
                            <span class="span">{{item.title}}</span>
                            <div class="xin">{{item.en_title}}</div>
                            <div class="details">Details</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- 底部 -->
        <Footer />
    </div>
</template>

<script>
    import Header from "../owned/header.vue"
    import Footer from "../owned/footer.vue"

    export default {
        components: {
            Header,
            Footer
        },
        data() {
            return {
                id: "",//二级模块ID
                module_id: '',//类型
                list: [],//页面内容
                olists: [],
            };
        },

        created() {
            this.id = this.$route.query.id
            this.module_id = this.$route.query.module_id
            this.getinfo()
        },
        inject: ["reload"],
        methods: {
            getinfo() {
                var that = this;
                that.$axios
                    .get(`${this.Baseurl}/search_module?id=${that.id}&module_id=${that.module_id}`)
                    .then(res => {
                        // console.log(res)
                        that.list = res.data.data
                        console.log(that.list)
                        that.olists = res.data.data.news
                    }).catch(err => console.log(err));
            },
            todetails(id) {

                this.$router.push({
                    name: 'Gramdetails', query: {
                        id: id,
                        module_id: this.module_id,
                    }
                })
            },

        },
        mounted() {

        },

    };
</script>
<style scoped>
    /* .newscont_bg {
        padding-top: 40px;
    } */

    /* .newscont {
        display: flex;
        flex-wrap: wrap;
    } */

    .anlist {
        width: 100%;
        height: 95vw;
        box-sizing: border-box;
        background-color: #fff;
        margin-bottom: 7vw;
        margin-left: 0;
        position: relative;
        border-bottom: 0.133vw solid #d0d0d0;
    }

    .anlist .fangan {
        position: absolute;
        width: 15.467vw;
        height: 6.667vw;
        top: 0;
        left: 0;
        z-index: 1;
        font-size: 3vw;
        color: #FFFFFF;
        line-height: 6.667vw;
        text-align: center;
        background-color: #2D64C8;
    }

    .anlist:nth-child(3n+1) {
        margin-left: 0;
    }

    .anlist .topimg {
        width: 100%;
        height: 57.600vw;
        display: block;
        overflow: hidden;
    }

    .anlist .topimg img {
        width: 100%;
        height: 100%;
        display: block;
        transition: all 0.3s;
    }

    .antext {
        width: 100%;
        margin: auto;
    }

    .anlist .antext .span {
        font-size: 4.2vw;
        color: #333333;
        margin-top: 2vw;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: block;
    }

    .anlist .antext .xin {
        font-size: 3.5vw;
        color: #333333;
        line-height: 5vw;
        height: 10vw;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-top: 2vw;
    }

    .details {
        width: 20vw;
        height: 8vw;
        border: 0.133vw solid #D0D0D0;
        box-sizing: border-box;
        text-align: center;
        font-size: 3vw;
        color: #454545;
        line-height: 8vw;
        background-color: #f7f7f7;
        margin: initial;
        margin-top: 3vw;
    }
</style>